import { BasePageProps } from "app/types";
import { useEffect, useState } from "react";
import { ArrowClockwise, ChatSquareText, FileText, BoxArrowInRight, PersonCheck } from "react-bootstrap-icons";
import { BoothWiseMatrixResponse, MatrixService } from "app/services/MatrixService";
import { useAppContext } from "app/context/app-context";

interface RecruiterBoothMatrixProps extends BasePageProps {
    boothId: string;
}

const RecruiterBoothMatrix = (props: RecruiterBoothMatrixProps) => {
    const [matrix, setMatrix] = useState<BoothWiseMatrixResponse | null>(null);
    const [refreshCount, setRefreshCount] = useState<number>(0);
    const { jobFair } = useAppContext();

    useEffect(() => {
        if (!jobFair?.id) {
            return;
        }
        const matrixService = new MatrixService();
        matrixService.getMatrixByJobFairIdAndBoothId(jobFair.id, props.boothId).then((response) => {
            if (response.isSuccess) {
                setMatrix(response.data);
            } else {
                setMatrix(null);
            }
        }).catch(() => {
            setMatrix(null);
        });

    }, [jobFair?.id, refreshCount, props.boothId]);

    return (
        <div className="d-flex flex-wrap gap-3 mb-3 position-relative">
            <span
                title="Refresh Matrix"
                onClick={() => setRefreshCount(value => value + 1)}
                style={{ cursor: "pointer", position: 'absolute', right: 0, top: '-25px' }}
                className="text-muted text-hover-primary"
            >
                <ArrowClockwise size={16} /> Refresh Stats
            </span>

            {/* Applicant Logins */}
            <div className="card h-100 border-0 shadow-sm flex-grow-1">
                <div className="card-body d-flex align-items-center p-3">
                    <div className="symbol symbol-40px me-3">
                        <div className="symbol-label bg-light-primary text-primary">
                            <BoxArrowInRight size={20} />
                        </div>
                    </div>
                    <div>
                        <div className="fs-4 fw-bolder text-gray-800">{matrix?.jobSeekerLogins || 0}</div>
                        <div className="text-muted fw-bold fs-8">Applicant Logins</div>
                    </div>
                </div>
            </div>

            {/* Entered Booth Queue */}
            <div className="card h-100 border-0 shadow-sm flex-grow-1">
                <div className="card-body d-flex align-items-center p-3">
                    <div className="symbol symbol-40px me-3">
                        <div className="symbol-label bg-light-success text-success">
                            <PersonCheck size={20} />
                        </div>
                    </div>
                    <div>
                        <div className="fs-4 fw-bolder text-gray-800">{matrix?.jobSeekersEnteredBooth || 0}</div>
                        <div className="text-muted fw-bold fs-8">Entered Queue</div>
                    </div>
                </div>
            </div>

            {/* Booth Interviews */}
            <div className="card h-100 border-0 shadow-sm flex-grow-1">
                <div className="card-body d-flex align-items-center p-3">
                    <div className="symbol symbol-40px me-3">
                        <div className="symbol-label bg-light-danger text-danger">
                            <ChatSquareText size={20} />
                        </div>
                    </div>
                    <div>
                        <div className="fs-4 fw-bolder text-gray-800">{matrix?.boothInterviews || 0}</div>
                        <div className="text-muted fw-bold fs-8">Interviews</div>
                    </div>
                </div>
            </div>

            {/* Resumes Left */}
            <div className="card h-100 border-0 shadow-sm flex-grow-1">
                <div className="card-body d-flex align-items-center p-3">
                    <div className="symbol symbol-40px me-3">
                        <div className="symbol-label bg-light-warning text-warning">
                            <FileText size={20} />
                        </div>
                    </div>
                    <div>
                        <div className="fs-4 fw-bolder text-gray-800">{matrix?.resumesLeftAtBooth || 0}</div>
                        <div className="text-muted fw-bold fs-8">Resumes Left</div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default RecruiterBoothMatrix;